var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m5.8 8.9h2.5v17.5h-2.5z","transform":"matrix(.7071 -.7071 .7071 .7071 -10.4464 10.1756)","key":0}),React.createElement("path",{"d":"m-1.7 5.8h17.5v2.5h-17.5z","transform":"matrix(.7071 -.7071 .7071 .7071 -2.9216 7.0534)","key":1})]);
}

ArrowInline.defaultProps = {"enableBackground":"new 0 0 14.1 24.8","viewBox":"0 0 14.1 24.8"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
